import { useState, useCallback } from 'react';

const useHeroCache = () => {
    const [heroCache, setHeroCache] = useState({});
    const [loadingHeroes, setLoadingHeroes] = useState(new Set());

    const loadHeroImage = useCallback(async (heroId) => {
        if (!heroId || heroId === 'N/A') return null;

        if (heroCache[heroId]) {
            return heroCache[heroId];
        }

        if (loadingHeroes.has(heroId)) {
            return null;
        }

        setLoadingHeroes(prev => new Set(prev).add(heroId));

        try {
            const response = await fetch(`https://api.deadlock-api.com/v1/assets/heroes/${heroId}?language=english`);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const heroData = await response.json();

            if (heroData && heroData.images) {
                const imageUrl = heroData.images.minimap_image ||
                    heroData.images.icon_hero_card ||
                    heroData.images.selection_image ||
                    heroData.images.icon_image_small;

                if (imageUrl) {
                    const weaponName = heroData.items?.weapon_primary || null;
                    const heroInfo = {
                        name: heroData.name,
                        imageUrl: imageUrl,
                        weaponName: weaponName
                    };

                    setHeroCache(prev => ({
                        ...prev,
                        [heroId]: heroInfo
                    }));

                    return heroInfo;
                }
            }

            return null;

        } catch {
            return null;
        } finally {
            setLoadingHeroes(prev => {
                const newSet = new Set(prev);
                newSet.delete(heroId);
                return newSet;
            });
        }
    }, [heroCache, loadingHeroes]);

    return { heroCache, loadHeroImage, loadingHeroes };
};

export default useHeroCache;
